import { useFileList } from "../../hooks/useFileList";
import {
    FileSnapshot,
    StatementType,
} from "@/entities/DataAssociation/File.model";
import { useRouter } from "@/utils";
import clsx from "clsx";
import { useSelectedFile } from "../../hooks/useSelectedFile";
import { FileMeta } from "../FileHeading/FileMeta";
import { DropdownMenu } from "@/ui/organisms";
import {
    fileListStatementTypeAtom,
    fileListStatusOptionsAtom,
} from "../../Labeling.state";
import { useAtom } from "jotai";
import {
    FileListStatementType,
    FileStatusOptions,
    STATEMENT_TYPE_LABELS,
} from "../../Labeling.types";

export const FileList = () => {
    const { files, isLoading } = useFileList();
    const [status, setStatus] = useAtom(fileListStatusOptionsAtom);
    const [statementType, setStatementType] = useAtom(
        fileListStatementTypeAtom,
    );
    const { selectedFileId } = useSelectedFile();
    const router = useRouter();

    if (isLoading)
        return (
            <>
                {[...Array(10)].map((_, i) => (
                    <div
                        key={i}
                        className={clsx(
                            "bg-selected h-20 w-full animate-pulse self-center rounded",
                        )}
                    />
                ))}
            </>
        );

    return (
        <div
            className={clsx(
                "mt-4 h-full",
                "flex flex-col",
                "min-h-0 overflow-hidden",
            )}
        >
            <div className="mb-4 flex justify-between px-3">
                <DropdownMenu
                    items={Object.values(FileStatusOptions).map((status) => ({
                        id: status,
                        label: status.charAt(0).toUpperCase() + status.slice(1),
                        onClick: () => setStatus?.(status),
                    }))}
                    selectedOptionId={status}
                />
                <DropdownMenu
                    selectedOptionId={statementType}
                    items={[...Object.values(StatementType), "all"].map(
                        (statementType) => ({
                            id: statementType,
                            label: STATEMENT_TYPE_LABELS[statementType],
                            onClick: () =>
                                setStatementType?.(
                                    statementType as FileListStatementType,
                                ),
                        }),
                    )}
                />
            </div>

            <ul
                className={clsx(
                    "flex flex-1 flex-col",
                    "hide-scrollbar min-h-0 gap-2 overflow-y-auto",
                )}
            >
                {files.map((file: FileSnapshot) => (
                    <li
                        className={clsx(
                            "card flex flex-col gap-2",
                            selectedFileId === file.id && "selected",
                        )}
                        key={file.id}
                        onClick={() => {
                            router.navigate(
                                `/beta/companies/${router.params.companyId}/labeling/files/${file.id}`,
                            );
                        }}
                    >
                        <div className="subdued">
                            <div className="flex cursor-pointer flex-col gap-2">
                                <p className="body-s cursor-pointer break-all pr-1">
                                    {file.name}
                                </p>
                                <FileMeta file={file} condensed />
                            </div>
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    );
};
